import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/hooks/use-toast";
import PageSeo from "@/components/PageSeo";

const AdminLogin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  
  const navigate = useNavigate();
  const { toast } = useToast();

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      if (session) navigate("/admin/events", { replace: true });
    });
  }, [navigate]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);

    try {
      {
        const { error } = await supabase.auth.signInWithPassword({ email, password });
        if (error) throw error;
        navigate("/admin/events");
      }
    } catch (error: any) {
      toast({ title: "Fehler", description: error.message, variant: "destructive" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <PageSeo
        title="Admin Login – Luther Club"
        description="Geschützter Login-Bereich für die Eventverwaltung des Luther Club."
        path="/admin"
        noindex
      />
      <div className="w-full max-w-sm space-y-6">
        <div className="text-center">
          <img src="/logo-white.png" alt="Luther Club" className="w-32 mx-auto mb-4" />
          <h1 className="text-2xl font-semibold text-primary">Admin Login</h1>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <Input
            type="email"
            placeholder="E-Mail"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required />
          
          <Input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required />
          
          <Button type="submit" className="w-full" disabled={loading}>
            {loading ? "..." : "Einloggen"}
          </Button>
        </form>

        




        
      </div>
    </div>);

};

export default AdminLogin;